import { useState } from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { createLeadMessage, createWhatsAppLink } from "../lib/whatsapp";

const initial = { nome: "", telefone: "", veiculo: "", local: "", servico: "", mensagem: "" };

export function LeadForm() {
  const [form, setForm] = useState(initial);
  const update = (field) => (event) => setForm((current) => ({ ...current, [field]: event.target.value }));
  const submit = (event) => {
    event.preventDefault();
    window.open(createWhatsAppLink(createLeadMessage(form)), "_blank", "noopener,noreferrer");
  };

  return (
    <form className="lead-form" onSubmit={submit} data-testid="lead-form">
      <label data-testid="lead-name-label">Nome<Input value={form.nome} onChange={update("nome")} placeholder="Seu nome" required data-testid="lead-name-input" /></label>
      <label data-testid="lead-phone-label">Telefone<Input value={form.telefone} onChange={update("telefone")} placeholder="(11) 99999-9999" required data-testid="lead-phone-input" /></label>
      <label data-testid="lead-vehicle-label">Tipo de veículo<Input value={form.veiculo} onChange={update("veiculo")} placeholder="Carro, moto, utilitário..." data-testid="lead-vehicle-input" /></label>
      <label data-testid="lead-location-label">Local onde está<Input value={form.local} onChange={update("local")} placeholder="Rua, bairro ou km da rodovia" required data-testid="lead-location-input" /></label>
      <label data-testid="lead-service-label">Serviço desejado<Input value={form.servico} onChange={update("servico")} placeholder="Guincho, reboque, pane seca..." data-testid="lead-service-input" /></label>
      <label className="full" data-testid="lead-message-label">Mensagem<Textarea value={form.mensagem} onChange={update("mensagem")} placeholder="Conte rapidamente o que aconteceu" data-testid="lead-message-input" /></label>
      <button className="btn btn-primary-red full" type="submit" data-testid="lead-form-submit-button">Enviar pelo WhatsApp</button>
    </form>
  );
}